import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { slideDrawer } from "../../reducers/UIReducer/UIActions";
import { setDataSuiteAllFilters, setDatasuiteDrawerContents, setSalesByOperator, setSalesByOperatorLoading, setSalesByCategory,
         setSalesByCategoryLoading, setTopOperator, setTrendingCategory, setTrendingSales, setWidgetCatalog, setGrowthOpportunity,
         setGrowthOpportunityLoading, setCategoriesFilter, setDistributorsFilter, setLocationsFilter, setSegmentsFilter, setStatesFilter,
         setLeakage, setLeakageLoading, setTargetsByCategory, setTargetsByCategoryLoading, setCompetitiveInsights, setCompetitiveInsightsLoading,
         setOpportunityByStoreLoading, setOpportunityByStore, setNewLocationsLoading, setNewLocations, setLostLocationsLoading,
         setLostLocations, setSalesVoidOpportunityLoading, setSalesVoidOpportunity, setDataSetsFilter, setDatasuiteDetailsDrawerContents, setBiggestGrowthOpportunity,
         setDataSetsDetailsFilter, setCategoriesDetailsFilter, setDistributorsDetailsFilter, setLocationsDetailsFilter, setSegmentsDetailsFilter, setStatesDetailsFilter,
         setSalesVoidOpportunityDetails, setCompetitiveInsightsDetails, setGrowthOpportunityDetails, setLeakageDetails,
         setLostLocationsDetails, setNewLocationsDetails, setOpportunityByStoreDetails,
         setSalesByCategoryDetails,setSalesByOperatorDetails, setTargetsByCategoryDetails, setItemLevelDescriptionData, setItemLevelDescriptionLoading, setDetailsPageLoading,
         setExcludedSearchDetailsFilter, setIncludedSearchDetailsFilter, setDistributorsExportFilter, setLocationsExportFilter, setCategoriesExportFilter, setSegmentsExportFilter, setDataSetsExportFilter,
         setGrowthOpportunityDetailsLoading, setSalesByOperatorDetailsLoading, setSalesByCategoryDetailsLoading, setLeakageDetailsLoading, setTargetsByCategoryDetailsLoading, setCompetitiveInsightsDetailsLoading,
         setOpportunityByStoreDetailsLoading, setNewLocationsDetailsLoading, setLostLocationsDetailsLoading, setSalesVoidOpportunityDetailsLoading,
         setCompCategoriesExportFilter, setCompDataSetsExportFilter, setCompLocationsExportFilter, setCompSegmentsExportFilter, setTopProducts, setTopProductsLoading, setTopProductsDetails,
         setTopCategories, setTopCategoriesLoading, setTopCategoriesDetails, setTopProductsDetailsLoading, setTopCategoriesDetailsLoading, 
         setSegmentOverview, setSegmentOverviewLoading, setSegmentOverviewDetails, setSegmentOverviewDetailsLoading, setItemMatchData, setItemMatchLoading, 
         setStatesExportFilter,
         setCompStatesExportFilter,
         setChildrenOptions, setChildrenFilter, setChildrenDetailsFilter} from "../../reducers/DatasuiteReducer/DataSuiteActions";
import { setDataSuiteSelectedWidgets } from "../../reducers/UserReducer/UserActions";
import LocalStorage from "../../sharedComponents/LocalStorage/LocalStorage";
import datasuiteApi from "../../api/datasuiteApi";
import widgetApi from "../../api/widgetApi";
import { toast } from 'react-toastify';
import { stringify } from "csv-stringify";
import fileDownload from "js-file-download";
import { setDsFromDate, setDsToDate, setDsDateString, setDsDetailsFromDate, setDsDetailsToDate, setDsDetailsDateString } from "../../reducers/DateReducer/DateActions";
import moment from "moment";
import { showModal } from "../../reducers/ModalsReducer/ModalsActions";
import ItemMatchModal from "../../sharedComponents/ItemMatch/ItemMatchModal";
import { setHighlightsLoading } from "../../reducers/DatasuiteReducer/DataSuiteActions";
import useManufacturerData from "../../sharedComponents/useManufacturerData/useManufacturerData";

const useWidgetControls = () => {
  const dispatch = useDispatch();

  const getWidgetCatalog = () => {
    widgetApi.all().then((res) => {
      dispatch(setWidgetCatalog(res.data));
    }).catch(err => {
      console.log(err);
    });
  }

  const getUserWidgetList = () => {
    widgetApi.get().then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickWidgetDrawerOpen = (title, replaceMode = false, replaceIndex = null) => {
    dispatch(setDatasuiteDrawerContents(title, replaceMode, replaceIndex));
    dispatch(slideDrawer.add());
  }

  const onClickWidgetDetailsDrawerOpen = (title, drawerContents) => {
    dispatch(setDatasuiteDetailsDrawerContents(title, drawerContents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const onClickAddWidget = (widget) => {
    dispatch(slideDrawer.subtract());
    widgetApi.subscribe({widgets: [widget.id]}).then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
      toast.success("Widget added");
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickReplaceWidget = (widget, position) => {
    dispatch(slideDrawer.subtract());
    widgetApi.replace({widgetId: widget.id, index: position}).then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
      toast.success("Widget replaced");
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickDeleteWidget = (widget) => {
    widgetApi.unsubscribe({widgets: [widget.id]}).then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
      toast.success("Widget deleted");
    }).catch(err => {
      console.log(err);
    });
  }


  return {
    getWidgetCatalog,
    getUserWidgetList,
    onClickWidgetDrawerOpen,
    onClickWidgetDetailsDrawerOpen,
    onClickAddWidget,
    onClickReplaceWidget,
    onClickDeleteWidget
  };
}

const useDataSuite = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mfrId = LocalStorage.manufacturerData.get().platform_id;
  const fromDate = useSelector(({dates}) => dates.datasuiteFromDate);
  const toDate = useSelector(({dates}) => dates.datasuiteToDate);
  const detailsFromDate = useSelector(({dates}) => dates.datasuiteDetailsFromDate);
  const detailsToDate = useSelector(({dates}) => dates.datasuiteDetailsToDate);
  const allFilters = useSelector(({datasuite}) => datasuite.allFilters);
  const selectedFilters = useSelector(({datasuite}) => datasuite.selectedFilters);
  const selectedDetailsFilters = useSelector(({datasuite}) => datasuite.selectedDetailsFilters);
  const salesByCategoryData = useSelector(({datasuite}) => datasuite.widgetData.salesByCategoryData);
  const lostLocationsData = useSelector(({datasuite}) => datasuite.widgetData.lostLocationsData);
  const newLocationsData = useSelector(({datasuite}) => datasuite.widgetData.newLocationsData);
  const targetsByCategoryData = useSelector(({datasuite}) => datasuite.widgetData.targetsByCategoryData);
  const leakageData = useSelector(({datasuite}) => datasuite.widgetData.leakageData);
  const growthOpportunityData = useSelector(({datasuite}) => datasuite.widgetData.growthOpportunityData);
  const [ filtersDrawerOpen, setFiltersDrawerOpen ] = useState(false);
  const chainData = useSelector(({user}) => user.chainData);
  const emergingData = useSelector(({user}) => user.emergingData);
  const { manufacturerParams } = useManufacturerData();

  const getHighlights = () => {
    dispatch(setHighlightsLoading(true));
    const operatorParams = {
      "chainData": chainData,
      "emergingData": emergingData,
      ...manufacturerParams
    };
    const salesParams = {
      "startDate": fromDate,
      "endDate": toDate,
      "chainData": chainData,
      "emergingData": emergingData,
      ...manufacturerParams
    };
    const categoriesParams = {
      "chainData": chainData,
      "emergingData": emergingData,
      ...manufacturerParams
    };
    const growthOpportunityParams = {
      "chainData": chainData,
      "emergingData": emergingData,
      ...manufacturerParams
    };

    const topOperator = datasuiteApi.highlights.topOperator.post(operatorParams).then((response) => {
      dispatch(setTopOperator(response.data));
    }).catch(err => {
      console.log(err);
    });
    const trendingSales = datasuiteApi.highlights.trendingSales.post(salesParams).then((response) => {
      dispatch(setTrendingSales(response.data));
    }).catch(err => {
      console.log(err);
    });
    const trendingCategory = datasuiteApi.highlights.trendingCategory.post(categoriesParams).then((response) => {
      dispatch(setTrendingCategory(response.data));
    }).catch(err => {
      console.log(err);
    });
    const growthOpportunity = datasuiteApi.highlights.growthOpportunity.post(growthOpportunityParams).then((response) => {
      dispatch(setBiggestGrowthOpportunity(response.data));
    }).catch(err => {
      console.log(err);
    });
    Promise.allSettled([topOperator, trendingSales, trendingCategory, growthOpportunity]).finally(() => {
      dispatch(setHighlightsLoading(false));
    });
  }

  const getTopOperatorReport = (contents) => {
    if (!salesByCategoryData) {
      getSalesByOperator();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Sales By Operator', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getTopGrowthOpportunityReport = (contents) => {
    if (!growthOpportunityData) {
      getGrowthOpportunity();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Growth Opportunities', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getLostOperatorTrendingReport = (contents) => {
    if (!lostLocationsData) {
      getLostLocations();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Lost Locations', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getOperatorTrendingReport = (contents) => {
    if (!newLocationsData) {
      getNewLocations();
    }
    dispatch(setDatasuiteDetailsDrawerContents('New Locations', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getCategoryTrendingReport = (contents) => {
    if (!targetsByCategoryData) {
      getTargetsByCategory();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Sales By Category', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getComplianceLeakageReport = (contents) => {
    if (!leakageData) {
      getLeakage();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Leakage', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const clickMoreFilters = (parentElement) => {
    switch (parentElement) {
      case ('') : {
        if(filtersDrawerOpen) {
          setFiltersDrawerOpen(false);
          document.getElementById('filtersDrawer').style.display = 'none';
        } else {
          setFiltersDrawerOpen(true);
          document.getElementById('filtersDrawer').style.display = 'flex';
        }
        break;
      }
      case ('Details') : {
        if(filtersDrawerOpen) {
          setFiltersDrawerOpen(false);
          document.getElementById('filtersDetailsDrawer').style.display = 'none';
        } else {
          setFiltersDrawerOpen(true);
          document.getElementById('filtersDetailsDrawer').style.display = 'flex';
        }
        break;
      }
      case ('DetailsPage') : {
        if(filtersDrawerOpen) {
          setFiltersDrawerOpen(false);
          document.getElementById('filtersDetailsPageDrawer').style.display = 'none';
        } else {
          setFiltersDrawerOpen(true);
          document.getElementById('filtersDetailsPageDrawer').style.display = 'flex';
        }
        break;
      }
     default : {
      // do nothing
     }
    }
  }

  const getFilters = () => {
    if(allFilters?.length <= 0) {
        const params = {
        "chainData": chainData,
        "emergingData": emergingData,
        "categories": selectedFilters?.categories,
        "distributors": selectedFilters?.distributors,
        "locations": selectedFilters?.locations,
        "children": selectedFilters?.children,
        "segments": selectedFilters?.segments,
        "states": selectedFilters?.states,
        ...manufacturerParams
      };
      datasuiteApi.filters.post(params).then((response) => {
        dispatch(setDataSuiteAllFilters(response.data));
      }).catch(err => {
        console.log(err);
      });
    }
  }

  const getSalesByOperator = (details = false, byChildLocation = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      "showChildLocations": byChildLocation,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };
    !details && dispatch(setSalesByOperatorLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSalesByOperatorDetailsLoading(true));
    datasuiteApi.widgets.salesByOperator.post(params).then((response) => {
      !details && dispatch(setSalesByOperator(response.data));
      dispatch(setSalesByOperatorDetails(response.data));
      !details && dispatch(setSalesByOperatorLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setSalesByOperatorDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

    const getSalesByOperatorItemLevel = (locationName, category) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": category,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": locationName,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      "filterByChild": true,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesByCategory = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };

    !details && dispatch(setSalesByCategoryLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSalesByCategoryDetailsLoading(true));
    datasuiteApi.widgets.salesByCategory.post(params).then((response) => {
      !details && dispatch(setSalesByCategory(response.data));
      dispatch(setSalesByCategoryDetails(response.data));
      !details && dispatch(setSalesByCategoryLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setSalesByCategoryDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesByCategoryItemLevel = (category) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": category,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getGrowthOpportunity = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      "getMatches": true,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };

    !details && dispatch(setGrowthOpportunityLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setGrowthOpportunityDetailsLoading(true));
    datasuiteApi.widgets.growthOpportunity.post(params).then((response) => {
      !details && dispatch(setGrowthOpportunity(response.data));
      dispatch(setGrowthOpportunityDetails(response.data));
      !details && dispatch(setGrowthOpportunityLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setGrowthOpportunityDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getGrowthOpportunityItemLevel = (operatorName, category) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": category,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": operatorName,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getLeakageItemLevel = (operatorName, category) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": category,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": operatorName,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getLeakage = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };
    !details && dispatch(setLeakageLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setLeakageDetailsLoading(true));
    datasuiteApi.widgets.leakage.post(params).then((response) => {
      !details && dispatch(setLeakage(response.data));
      dispatch(setLeakageDetails(response.data));
      !details && dispatch(setLeakageLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setLeakageDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTargetsByCategory = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };
    !details && dispatch(setTargetsByCategoryLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setTargetsByCategoryDetailsLoading(true));
    datasuiteApi.widgets.targetsByCategory.post(params).then((response) => {
      !details && dispatch(setTargetsByCategory(response.data));
      dispatch(setTargetsByCategoryDetails(response.data));
      !details && dispatch(setTargetsByCategoryLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setTargetsByCategoryDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTargetsByCategoryItemLevel = (category) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": category,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getCompetitiveInsights = (details = false) => {
    !details && dispatch(setCompetitiveInsightsLoading(true));
    details && dispatch(setCompetitiveInsightsDetailsLoading(true));
    if(allFilters?.categories?.length > 0) {
      let categories;
      if (details) {
        categories = (selectedDetailsFilters?.categories?.length > 0) ? selectedDetailsFilters?.categories : allFilters?.categories;
      } else {
        categories = (selectedFilters?.categories?.length > 0) ? selectedFilters?.categories : allFilters?.categories;
      }
      const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      ...manufacturerParams
      } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      ...manufacturerParams
      };
      datasuiteApi.widgets.competitiveInsights.post(params).then((response) => {
        !details && dispatch(setCompetitiveInsights(response.data));
        dispatch(setCompetitiveInsightsDetails(response.data));
        !details && dispatch(setCompetitiveInsightsLoading(false));
        details && dispatch(setDetailsPageLoading(false));
        details && dispatch(setCompetitiveInsightsDetailsLoading(false));
      }).catch(err => {
        console.log(err);
      });
    }
  }

  const getOpportunityByStore = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };

    !details && dispatch(setOpportunityByStoreLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setOpportunityByStoreDetailsLoading(true));
    datasuiteApi.widgets.opportunityByStore.post(params).then((response) => {
      !details && dispatch(setOpportunityByStore(response.data));
      dispatch(setOpportunityByStoreDetails(response.data));
      !details && dispatch(setOpportunityByStoreLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setOpportunityByStoreDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getNewLocations = (details = false, filterByChild = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      "filterByChild": filterByChild,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };

    !details && dispatch(setNewLocationsLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setNewLocationsDetailsLoading(true));
    datasuiteApi.widgets.newLocations.post(params).then((response) => {
      !details && dispatch(setNewLocations(response.data));
      dispatch(setNewLocationsDetails(response.data));
      !details && dispatch(setNewLocationsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setNewLocationsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getNewLocationsItemLevel = (locationName) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": locationName,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      "filterByChild": true,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getLostLocations = (details = false, filterByChild = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      "filterByChild": filterByChild,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };

    !details && dispatch(setLostLocationsLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setLostLocationsDetailsLoading(true));
    datasuiteApi.widgets.lostLocations.post(params).then((response) => {
      !details && dispatch(setLostLocations(response.data));
      dispatch(setLostLocationsDetails(response.data));
      !details && dispatch(setLostLocationsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setLostLocationsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesVoidOpportunity = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };

    !details && dispatch(setSalesVoidOpportunityLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSalesVoidOpportunityDetailsLoading(true));
    datasuiteApi.widgets.salesVoid.post(params).then((response) => {
      !details && dispatch(setSalesVoidOpportunity(response.data));
      dispatch(setSalesVoidOpportunityDetails(response.data));
      !details && dispatch(setSalesVoidOpportunityLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setSalesVoidOpportunityDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesVoidItemLevel = (locationName) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": locationName,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTopProducts = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };
    !details && dispatch(setTopProductsLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setTopProductsDetailsLoading(true));
    datasuiteApi.widgets.topProducts.post(params).then(response => {
      !details && dispatch(setTopProducts(response.data));
      dispatch(setTopProductsDetails(response.data));
      !details && dispatch(setTopProductsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setTopProductsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTopCategories = (details = false) => {
    const params = details ? {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    } : {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    };
    !details && dispatch(setTopCategoriesLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setTopCategoriesDetailsLoading(true));
    datasuiteApi.widgets.topCategories.post(params).then(response => {
      !details && dispatch(setTopCategories(response.data));
      dispatch(setTopCategoriesDetails(response.data));
      !details && dispatch(setTopCategoriesLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setTopCategoriesDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSegmentOverview = (details = false) => {
    const params = details ? {
      "manufacturerPlatformId": mfrId,
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children
    } : {
      "manufacturerPlatformId": mfrId,
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.gpoData,
      "startDate": fromDate,
      "endDate": toDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children
    };

    !details && dispatch(setSegmentOverviewLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSegmentOverviewDetailsLoading(true));
    datasuiteApi.widgets.segmentOverview.post(params).then((response) => {
        !details && dispatch(setSegmentOverview(response.data));
        dispatch(setSegmentOverviewDetails(response.data));
        !details && dispatch(setSegmentOverviewLoading(false));
        details && dispatch(setDetailsPageLoading(false));
        details && dispatch(setSegmentOverviewDetailsLoading(false));
      })
      .catch(err => {
        console.log(err);
      });
  };

  const setSelectedDataSets = (datasets, details = false) => {
    if(datasets?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if (datasets) {
      const chainData = datasets.findIndex((ds) => ds.value === "Chain Data") > -1;
      const gpoData = datasets.findIndex((ds) => ds.value === "Emerging Chain Data") > -1;
      dispatch(setDataSetsDetailsFilter(chainData, gpoData));
      !details && dispatch(setDataSetsFilter(chainData, gpoData));
      const parents = details ? selectedDetailsFilters?.locations : selectedFilters?.locations;
      if (parents && parents.length) {
        fetchChildrenOptions(parents, details);
      }
    } else {
      dispatch(setDataSetsDetailsFilter(selectedFilters?.chainData, selectedFilters?.gpoData));
    }
  }

  const setExcludedSearchKeywords = (keyword) => {
    if(keyword?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(keyword) {
      var excludedKeywords = selectedDetailsFilters.excludedSearch;
      if (excludedKeywords.indexOf(keyword) === -1) {
        excludedKeywords.push(keyword.toLowerCase());
        dispatch(setExcludedSearchDetailsFilter(excludedKeywords));
      }
    } else {
      dispatch(setExcludedSearchDetailsFilter([]));
    }
  }

  const setIncludedSearchKeywords = (keyword) => {
    if(keyword?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(keyword) {
      var includedKeywords = selectedDetailsFilters.includedSearch;
      if(includedKeywords.indexOf(keyword) === -1) {
        includedKeywords.push(keyword.toLowerCase());
        dispatch(setIncludedSearchDetailsFilter(includedKeywords));
      }
    } else {
      dispatch(setIncludedSearchDetailsFilter([]));
    }
  }

  const removeExcludedSearchKeyword = (keyword) => {
    var excludedKeywords = selectedDetailsFilters.excludedSearch;
    excludedKeywords = excludedKeywords.filter((tag) => tag !== keyword);
    dispatch(setExcludedSearchDetailsFilter(excludedKeywords));
  }

  const removeIncludedSearchKeyword = (keyword) => {
    var includedKeywords = selectedDetailsFilters.includedSearch;
    includedKeywords = includedKeywords.filter((tag) => tag !== keyword);
    dispatch(setIncludedSearchDetailsFilter(includedKeywords));
  }

  const setSelectedCategories = (categories, details = false) => {
    if(categories?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(categories) {
      const mappedCategories = categories.map(category => category.value);
      dispatch(setCategoriesDetailsFilter(mappedCategories));
      !details && dispatch(setCategoriesFilter(mappedCategories));
    } else {
      dispatch(setCategoriesDetailsFilter([]));
      !details && dispatch(setCategoriesFilter([]));
    }
  }

  const setSelectedDistributors = (distributors, details = false) => {
    if(distributors?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(distributors) {
      const mappedDistributors = distributors.map(distributor => distributor.value);
      dispatch(setDistributorsDetailsFilter(mappedDistributors));
      !details && dispatch(setDistributorsFilter(mappedDistributors));
    } else {
      dispatch(setDistributorsDetailsFilter([]));
      !details && dispatch(setDistributorsFilter([]));
    }
  }

  const fetchChildrenOptions = async (parentLocations, details = false) => {
    if (!Array.isArray(parentLocations) || parentLocations.length === 0) {
      if (details) {
        dispatch(setChildrenDetailsFilter([]));
      } else {
        dispatch(setChildrenOptions([]));
        dispatch(setChildrenFilter([]));
      }
      return;
    }
    const parents = parentLocations.map(p => (typeof p === 'string' ? p : p?.value ?? p?.label ?? p?.name)).filter(Boolean);
    const payload = {
      manufacturerPlatformId: mfrId,
      chainData: details ? selectedDetailsFilters?.chainData : selectedFilters?.chainData,
      emergingData: details ? selectedDetailsFilters?.gpoData : selectedFilters?.gpoData,
      startDate: details ? detailsFromDate : fromDate,
      endDate: details ? detailsToDate : toDate,
      parents,
    };
    try {
      const { data } = await datasuiteApi.filters.children.post(payload);
      const arr = Array.isArray(data) ? data : [];
      const sortedChildren = [...new Set(arr)].sort();
      dispatch(setChildrenOptions(sortedChildren));
      if (details) {
        const validSelectedChildren = selectedDetailsFilters.children.filter(c => sortedChildren.includes(c));
        dispatch(setChildrenDetailsFilter(validSelectedChildren));
      } else {
        const validSelectedChildren = selectedFilters.children.filter(c => sortedChildren.includes(c));
        dispatch(setChildrenFilter(validSelectedChildren));
      }
    } catch {
      if (details) {
        dispatch(setChildrenDetailsFilter([]));
      } else {
        dispatch(setChildrenOptions([]));
        dispatch(setChildrenFilter([]));
      }
    }
  };

  const setSelectedLocations = (locations, details = false) => {
    if(locations?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(locations) {
      const mappedLocations = locations.map(location => location.value);
      if (details) {
        dispatch(setLocationsDetailsFilter(mappedLocations));
      } else {
        dispatch(setLocationsFilter(mappedLocations));
      }
      fetchChildrenOptions(mappedLocations, details);
    } else {
      dispatch(setLocationsDetailsFilter([]));
      !details && dispatch(setLocationsFilter([]));
      dispatch(setChildrenOptions([]));
    }
  }

  const setSelectedChildren = (children, details = false) => {
    if(children?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if (children) {
      const mappedChildren = children.map(c => c.value);
      dispatch(setChildrenDetailsFilter(mappedChildren));
      !details && dispatch(setChildrenFilter(mappedChildren));
    } else {
      dispatch(setChildrenDetailsFilter([]));
      !details && dispatch(setChildrenFilter([]));
    }
  };

  const setSelectedSegments = (segments, details = false) => {
    if(segments?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(segments) {
      const mappedSegments = segments.map(segment => segment.value);
      dispatch(setSegmentsDetailsFilter(mappedSegments));
      !details && dispatch(setSegmentsFilter(mappedSegments));
    } else {
      dispatch(setSegmentsDetailsFilter([]));
      !details && dispatch(setSegmentsFilter([]));
    }
  }

  const setSelectedStates = (states, details = false) => {
    if(states?.length > 0) {
      toast.info("Applying filters.", {autoClose: 5000});
    }
    if(states) {
      const mappedStates = states.map(state => state.value);
      dispatch(setStatesDetailsFilter(mappedStates));
      !details && dispatch(setStatesFilter(mappedStates));
    } else {
      dispatch(setStatesDetailsFilter([]));
      !details && dispatch(setStatesFilter([]));
    }
  }

  const changeDataSuiteDates = (fromDate, toDate, details = false) => {
    toast.info("Applying filters.", {autoClose: 15000});
    const dateString = moment(fromDate).format('YYYY-MM-DD') + " - " + moment(toDate).format('YYYY-MM-DD');
    if (details) {
      dispatch(setDsDetailsFromDate(fromDate));
      dispatch(setDsDetailsToDate(toDate));
      dispatch(setDsDetailsDateString(dateString));
    } else {
      dispatch(setDsFromDate(fromDate));
      dispatch(setDsToDate(toDate));
      dispatch(setDsDateString(dateString));
    }
  }

  const filterTargetsByCategoryTable = () => {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("targetsByCategorySearchInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("targetsByCategoryTable");
    tr = table.getElementsByClassName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByClassName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  const filterTargetsByCategoryDetailsTable = () => {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("targetsByCategoryDetailsSearchInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("targetsByCategoryDetailsTable");
    tr = table.getElementsByClassName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByClassName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  const onClickViewDetails = (widgetName, filteredItem, filteredItem2) => {
    switch (widgetName) {
      case ("Competitive Insights") : {
        break;
      }
      case ("Growth Opportunities") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        break;
      }
      case ("Leakage") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        dispatch(setCategoriesDetailsFilter([filteredItem2]));
        break;
      }
      case ("Lost Locations") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        break;
      }
      case ("New Locations") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        break;
      }
      case ("Opportunities By Distributor") : {
        dispatch(setDistributorsDetailsFilter([filteredItem]));
        break;
      }
      case ("Opportunities By Store") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        break;
      }
      case ("Sales By Category") : {
        dispatch(setCategoriesDetailsFilter([filteredItem]));
        break;
      }
      case ("Sales By Operator") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        break;
      }
      case ("Sales Void Opportunities") : {
        dispatch(setLocationsDetailsFilter([filteredItem]));
        break;
      }
      case ("Targets By Category") : {
        dispatch(setCategoriesDetailsFilter([filteredItem]));
        break;
      }
      case ("Segment Overview"): {
        dispatch(setSegmentsDetailsFilter([filteredItem]));
        break;
      }
      default : {
        // Do nothing
      }
    }
    navigate({pathname: '/salesstream/details', search: "?" + widgetName});
  }

  const onClickViewItemMatches = (location, category) => {
    dispatch(showModal(ItemMatchModal, {category: category, location: location}));
  }

  const getItemMatches = (locationName, category) => {
    const params = {
      "chainData": selectedDetailsFilters?.chainData,
      "emergingData": selectedDetailsFilters?.gpoData,
      "startDate": detailsFromDate,
      "endDate": detailsToDate,
      "categories": category ? category : selectedDetailsFilters?.categories,
      "distributors": selectedDetailsFilters?.distributors,
      "locations": locationName ? locationName : selectedDetailsFilters?.locations,
      "segments": selectedDetailsFilters?.segments,
      "states": selectedDetailsFilters?.states,
      "searchInclude": selectedDetailsFilters?.includedSearch,
      "searchExclude": selectedDetailsFilters?.excludedSearch,
      "children": selectedDetailsFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemMatchLoading(true));
    datasuiteApi.itemMatch.post(params).then((response) => {
      dispatch(setItemMatchData(response.data));
      dispatch(setItemMatchLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickItemMatchesExport = (itemMatches, mfrName, category) => {
    if (itemMatches) {
      let csvData = [];
      // CSV column headers
      csvData.push([
        'MIN',
        'Description',
        'Category',
        'Pack Size',
        'Cases'
      ]);

      itemMatches.forEach(itemMatch => {
        // CSV data rows
        csvData.push([
          itemMatch.match_min,
          itemMatch.match_description,
          category,
          itemMatch.match_pack,
          itemMatch.total_cases
        ]);
      });

      // Start the Download
      stringify(csvData, (err, output) => {
        if (err) {
          console.error('Error generating CSV:', err);
          return;
        }
        fileDownload(output, `MatchedItems_${mfrName.replaceAll(' ', '')}_${category.replaceAll(' ', '')}_${moment().format('DDMMYYYY_hmmss').toString()}.csv`);
      });
    }
  }

  const updateExportFilters = () => {
    dispatch(setDistributorsExportFilter(selectedDetailsFilters.distributors));
    dispatch(setLocationsExportFilter(selectedDetailsFilters.locations));
    dispatch(setCategoriesExportFilter(selectedDetailsFilters.categories));
    dispatch(setSegmentsExportFilter(selectedDetailsFilters.segments));
    dispatch(setDataSetsExportFilter(selectedDetailsFilters.chainData, selectedDetailsFilters.gpoData));
    dispatch(setStatesExportFilter(selectedDetailsFilters.states));
  }

  const updateCompExportFilters = () => {
    dispatch(setCompLocationsExportFilter(selectedDetailsFilters.locations));
    dispatch(setCompCategoriesExportFilter(selectedDetailsFilters.categories));
    dispatch(setCompSegmentsExportFilter(selectedDetailsFilters.segments));
    dispatch(setCompDataSetsExportFilter(selectedDetailsFilters.chainData, selectedDetailsFilters.gpoData));
    dispatch(setCompStatesExportFilter(selectedDetailsFilters.states));
  }

  const clearDetailsFilter = () => {
    setSelectedDataSets();
    dispatch(setLocationsDetailsFilter([]));
    dispatch(setCategoriesDetailsFilter([]));
    dispatch(setDistributorsDetailsFilter([]));
    dispatch(setSegmentsDetailsFilter([]));
    dispatch(setStatesDetailsFilter([]));
    dispatch(setIncludedSearchDetailsFilter([]));
    dispatch(setExcludedSearchDetailsFilter([]));
  }

  return {
    getHighlights,
    getTopOperatorReport,
    getTopGrowthOpportunityReport,
    getOperatorTrendingReport,
    getLostOperatorTrendingReport,
    getCategoryTrendingReport,
    getComplianceLeakageReport,
    clickMoreFilters,
    filtersDrawerOpen,
    getFilters,
    getSalesByOperator,
    getSalesByCategory,
    getGrowthOpportunity,
    getLeakage,
    getTargetsByCategory,
    getCompetitiveInsights,
    setSelectedDataSets,
    setSelectedCategories,
    setSelectedDistributors,
    setSelectedLocations,
    setSelectedSegments,
    setSelectedStates,
    changeDataSuiteDates,
    filterTargetsByCategoryTable,
    filterTargetsByCategoryDetailsTable,
    getOpportunityByStore,
    getNewLocations,
    getLostLocations,
    getSalesVoidOpportunity,
    onClickViewDetails,
    getNewLocationsItemLevel,
    getSalesByOperatorItemLevel,
    getSalesByCategoryItemLevel,
    getGrowthOpportunityItemLevel,
    getLeakageItemLevel,
    getSalesVoidItemLevel,
    getTargetsByCategoryItemLevel,
    clearDetailsFilter,
    setIncludedSearchKeywords,
    setExcludedSearchKeywords,
    removeIncludedSearchKeyword,
    removeExcludedSearchKeyword,
    updateExportFilters,
    getItemMatches,
    onClickViewItemMatches,
    onClickItemMatchesExport,
    updateCompExportFilters,
    getTopProducts,
    getTopCategories,
    getSegmentOverview,
    setSelectedChildren
  };
}

// eslint-disable-next-line
export default { useWidgetControls, useDataSuite };
